import { merge } from 'lodash';
import { createI18n, I18n } from 'vue-i18n';

import { fetchLocale } from './fetch-locale';
import { I18N_FALLBACK_CONF } from '@skinsoft/config'

declare const config
const FALLBACK_LOCALE = config.fallback_locale

let instance = null as any;

export function createInstance(messages, locale = FALLBACK_LOCALE, dateTimeFormats): I18n {
    const instance = createI18n({
        // legacy mode keeps `this.$i18n` / `this.$t` working unchanged in every Options API component
        legacy: true,
        datetimeFormats: dateTimeFormats,
        fallbackLocale: I18N_FALLBACK_CONF,
        silentFallbackWarn: true,
        locale,
        messages,
    });

    // vue-i18n 9 hard-throws on a non-string `$t()` key; keep vue-i18n 8's lenient behaviour since
    // several components call `$t(someOptionalProp)`.
    const g = instance.global as any;
    const originalT = g.t.bind(g);
    g.t = (key: any, ...rest: any[]) => (typeof key === 'string' ? originalT(key, ...rest) : key ?? '');

    return instance;
}

export async function i18n(messages, dateTimeFormats): Promise<I18n> {
    if (instance) {
        return instance;
    }

    const locale = localStorage.getItem('preferredLocale') || navigator.language.split('-')[0] || FALLBACK_LOCALE;
    let remoteMessages = {};

    try {
        remoteMessages = await fetchLocale(locale)
    } catch (error) {
        // tslint:disable-next-line:no-console
        console.error("An error happened while fetching translations")
        console.error(error);
    }

    instance = createInstance(merge(remoteMessages, messages), locale, dateTimeFormats);

    return instance;
}
